import { render, staticRenderFns } from "./AppdbJitpair.vue?vue&type=template&id=0a3e158d&scoped=true"
import script from "./AppdbJitpair.vue?vue&type=script&lang=js"
export * from "./AppdbJitpair.vue?vue&type=script&lang=js"
import style0 from "./AppdbJitpair.vue?vue&type=style&index=0&id=0a3e158d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3e158d",
  null
  
)

export default component.exports